import { use } from 'react';
import { ErrorContext } from '@/app/providers/ErrorContext';

export function useError() {
  const context = use(ErrorContext);
  if (context === undefined) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
}
